import {Routes} from '@angular/router';
import {AuthGuard} from 'amc-common-components';

export const RightsRoutes: Routes = [
	{
		path: 'rights',
		canActivate: [AuthGuard],
		loadChildren: () => import('../rights.module').then((m) => m.RightsModule),
	},
];

export const RightsPageFiltersRoutes: Routes = [
	{
		path: 'rights',
		canActivate: [AuthGuard],
		loadChildren: () =>
			import('../components/rights-page-filters/rights-page-filters.module').then(
				(m) => m.RightsPageFiltersModule
			),
		outlet: 'filters',
	},
];
